module.exports = __webpack_public_path__ + "static/Apricot-fa4fe5d6fc55d64680ffb20608d13973.png";